module.exports = __webpack_public_path__ + "img/continue-button.ab843cd5.png";